module.exports = __webpack_public_path__ + "media/images/pic/brodno/cambridge-prepare2-7107797a1463edc2e230be3160942c83.png";